// extracted by mini-css-extract-plugin
export default {"doubleColumn":"StatsRows_doubleColumn__T8ihr","singleColumn":"StatsRows_singleColumn__90AKH"};